import { flow, types } from 'mobx-state-tree';
import { isNextServer } from '@/intl-jdi-common-ssr/utils/uaParser';
import { getLoginInfoApi } from '@/apis/login/login.api';
import { withSetPropAction } from '@/models/helpers/withSetPropAction';

interface UserInfo {
  pin: string | null;
  nickName: string | null;
  avatar: string | null;
}

const UserInfoModel = types.model('UserInfo', {
  pin: types.maybeNull(types.string),
  nickName: types.maybeNull(types.string),
  avatar: types.maybeNull(types.string),
});

export const UserInfoStore = types
  .model('UserInfoStore')
  .props({
    loading: false, // 新增加载标记
    userInfo: types.maybeNull(UserInfoModel),
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    /**
     * 统一获取UserInfo
     * @param force 是否强制刷新
     */
    fetchUserInfo: flow(function* (force = true) {
      if (self.loading) return;

      // 只有在客户端的时候才去更新UserInfo，服务端在store里不执行
      if (isNextServer()) {
        return;
      }
      // 如果已有数据且不强制刷新 → 直接返回
      if (self.userInfo && !force) {
        return;
      }

      self.loading = true;
      try {
        const [err, res] = yield getLoginInfoApi(
          { types: [6] },
          { meta: { forceIgnoreLogin: true } },
        );
        if (err) {
          console.error('User info not found in response', err);
          return;
        }
        if (res?.success && res.data) {
          self.userInfo = res.data;
        } else {
          self.userInfo = null;
        }
      } finally {
        self.loading = false;
      }
    }),
    /**
     * 直接更新UserInfo
     */
    setUserInfo(userInfo: UserInfo | null) {
      self.userInfo = userInfo;
    },
  }));
